/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：135
 */

"use strict"

export { IconWidgetAudio as c }
export { o as f }
export { i as g }
export { a as d }
export { s as e }
export { c as b }
export { l as a }
export { Audio_aacAudio_oggAudio_mpegAudio_waveAudio_wavAudio_xWavAudio_webm as h }
var /* [auto-meaningful-name] */IconWidgetAudio = "icon-widget-audio"
var o = 100
var i = 0
var a = 400
var s = 50
var c = true
var l = false
var /* [auto-meaningful-name] */Audio_aacAudio_oggAudio_mpegAudio_waveAudio_wavAudio_xWavAudio_webm = "audio/aac, audio/ogg, audio/mpeg, audio/wave, audio/wav, audio/x-wav, audio/webm"
export default l
